import React from 'react'

export default function Login(props) {
  return (
    <>
    <div className='col-md-10 content'>

    <h1>Now you are in login page</h1>

    <h1>Name of user -{props.name}</h1>

    <h1>Age of user - {props.age}</h1>

     </div>
    
    </>
  )
}
